import { Feature, getFeatureAvailableFromState } from 'App/components/hooks/featureHelper';
import history from 'App/pages/routes/history';
import { RootState } from 'Store/index';
import StateRouter from 'App/services/StateRouter';

type App = RootState['App'];

// Stricter than the backend's rights check: the user's own "Turn off Bisnode" opt-out applies to admins too.
export const canOfferSoliditet = (self: App['self'], metadata: App['metadata'], bulk = false) =>
	!!(
		metadata?.params?.soliditetIsActive &&
		self?.userParams?.soliditetIsActive &&
		(!bulk || self.administrator || self.userParams.multiSoliditetAccess)
	);

export const canFindSoliditetProspects = (
	self: App['self'],
	accountSelf: App['accountSelf'],
	metadata: App['metadata']
) => getFeatureAvailableFromState(accountSelf, Feature.SOLIDITET) && canOfferSoliditet(self, metadata, true);

export const canFindProspects = ({ self, accountSelf, metadata }: Pick<App, 'self' | 'accountSelf' | 'metadata'>) =>
	getFeatureAvailableFromState(accountSelf, Feature.PROSPECTING_BASIC)
		? !!(self?.administrator || self?.userParams.multiSoliditetAccess)
		: canFindSoliditetProspects(self, accountSelf, metadata);

export const goToFindProspects = (accountSelf: App['accountSelf']) => {
	if (getFeatureAvailableFromState(accountSelf, Feature.PROSPECTING_BASIC)) {
		history.push('/prospecting');
	} else {
		StateRouter.go('findProspects');
	}
};
